export default __webpack_public_path__ + "static/media/loginbg.ba009319.jpg";